import { render } from "./Dropdown2.vue?vue&type=template&id=4575f47c"
import script from "./Dropdown2.vue?vue&type=script&lang=ts"
export * from "./Dropdown2.vue?vue&type=script&lang=ts"
script.render = render

export default script